import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ILoaiSucKhoeActionTypes } from "../../action-types/danh-muc/ILoaiSucKhoeActionTypes";
import { ILoaiSucKhoeReducer } from "../../page-state-model/danh-muc/ILoaiSucKhoeReducer";
const iniState: ILoaiSucKhoeReducer = {
    status: ePageBaseStatus.is_not_initialization,
    loaiSucKhoes: []
}
export const loaiSucKhoeReducer = (state: ILoaiSucKhoeReducer = iniState, action: ILoaiSucKhoeActionTypes): ILoaiSucKhoeReducer => {
    switch (action.type) {
        case "LOAI_SUC_KHOE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "LOAI_SUC_KHOE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                loaiSucKhoes: action.payload
            }
        case "LOAI_SUC_KHOE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                loaiSucKhoes: []
            }
        case "LOAI_SUC_KHOE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "LOAI_SUC_KHOE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "LOAI_SUC_KHOE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "LOAI_SUC_KHOE_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "LOAI_SUC_KHOE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "LOAI_SUC_KHOE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "LOAI_SUC_KHOE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "LOAI_SUC_KHOE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}